import Link from 'next/link';

export default function FourOhFour() {
  return (
    <div className="bg-lift-black fixed inset-0 z-[950] flex h-screen w-full items-center justify-center overflow-auto px-6 py-32">
      <div className="m-auto text-center">
        <div className="space-y-12">
          <div className="space-y-16">
            <Link href="/" className="inline-block size-24">
              <svg
                className="text-lift-tan block size-full fill-current"
                viewBox="0 0 34 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.2808 24.0062L15.7362 32.7259V0.611816L0.210815 4.72356V37.6884H33.1756V20.2489L19.2808 24.0062Z"
                  fill="currentColor"
                />
                <path
                  d="M25.661 20.0363C30.0852 20.0363 33.6718 16.4497 33.6718 12.0255C33.6718 7.60121 30.0852 4.01465 25.661 4.01465C21.2367 4.01465 17.6502 7.60121 17.6502 12.0255C17.6502 16.4497 21.2367 20.0363 25.661 20.0363Z"
                  fill="#F0454A"
                />
              </svg>
            </Link>
            <h1 className="eros-ss02 text-display-7xl text-lift-tan md:text-display-7xl lg:text-display-8xl col-span-12 font-display">
              404
            </h1>
          </div>
          <div className="space-y-12">
            <div className="space-y-4">
              <p className="text-lift-tan text-5xl">Page Not Found</p>
              <p className="text-md text-lift-tan/60">
                Sorry, the page you’re looking for doesn’t exist.
              </p>
            </div>
            <Link
              href="/"
              className="text-md text-lift-red inline-block duration-300 hover:opacity-70"
            >
              <>Back to Home</>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
